import * as S3 from 'aws-sdk/clients/s3';
import {from, Observable} from "rxjs";

interface UploadOptions {
  maxSize?: {value: number, error: string},
  acceptedTypes?: {value: string[], allowImg: boolean, error: string}
}
export interface UploadResponse {
  ok: boolean,
  error?: string,
  uploadResponse?: Promise<{src: string}>
}
const ConstantVariable = {
  cdnImages: `https://d2idjfaj943a7l.cloudfront.net/`
}
export class FileUploadUtil {
  private cdnImage: string;
  private static createGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
  private static isFileUnderSize(size: number, maxSize?: {value: number, error: string}) {
    return !maxSize || (maxSize && size <= maxSize.value);
  }
  constructor(private accessKeyId: string, private secretAccessKey: string, private region: string, private awsFolderFiles: string) {
    this.cdnImage = ConstantVariable.cdnImages + awsFolderFiles;
  }
  uploadS3Observable(file: Blob | File, uploadOptions: UploadOptions | null = null, fileNamePrefix = null): Observable<{src: string}> {
    const up = this.uploadS3(file, uploadOptions, fileNamePrefix);
    if (!up.ok || !up.uploadResponse) {
      throw new Error(up.error);
    }
    return from(up.uploadResponse);
  }
  uploadS3(file: Blob | File, uploadOptions: UploadOptions | null = null, fileNamePrefix = null): UploadResponse {
    if (uploadOptions) {
      if (FileUploadUtil.isFileUnderSize(file.size, uploadOptions.maxSize)) {
        if (this.isCorrectType(file, uploadOptions.acceptedTypes)) {
          return {ok: true, uploadResponse: this.uploadFileToS3(file, fileNamePrefix)};
        } else {
          return {error: uploadOptions.acceptedTypes?.error, ok: false};
        }
      } else {
        return {error: uploadOptions.maxSize?.error, ok: false};
      }
    }
    return {ok: true, uploadResponse: this.uploadFileToS3(file, fileNamePrefix)};
  }
  private async uploadFileToS3(file: Blob | File, fileNamePrefix = null): Promise<{src: string}> {
    const type = file instanceof Blob ? file.type.split('/').pop()?.split(';')[0] : (file as File).name.split('.').pop();
    const fileData = {
      name: fileNamePrefix === null ? FileUploadUtil.createGuid() + '.' + type :
        fileNamePrefix + FileUploadUtil.createGuid() + '.' + type,
      src: ''
    };
    const {bucket, params} = this.getBucket(file, fileData.name);
    const upload = bucket.upload(params);
    fileData.src = this.cdnImage + fileData.name;
    return upload.promise().then(res => {
      return {...res, src: this.cdnImage + fileData.name};
    });
  }
  private getBucket(file: Blob, fileName: string) {
    return {bucket: new S3({
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey,
        region: this.region
      }), params: {
        Bucket: 'frontdoorapp',
        Key: this.awsFolderFiles + fileName,
        Body: file,
        ACL: 'public-read',
      }};
  }
  private isCorrectType(file: Blob, acceptedTypes?: {value: string[], allowImg: boolean, error: string}) {
    if (acceptedTypes) {
      const type = file.type.split('.').pop() ?? '';
      if (acceptedTypes.value.includes(type)) {
        return true;
      }
      if (acceptedTypes.allowImg) {
        return this.isFileImg(file);
      }
      return false;
    }
    return true;
  }
  isFileImg(file: Blob) {
    const fileType = file.type.split('/');
    return fileType[0] === 'image';
  }
}
